import { useState } from 'react'

const allStatus = {
    INIT: 'init',
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
}

const useStatus = () => {
    const [status, setStatus] = useState(allStatus.INIT)

    const setInit = () => setStatus(allStatus.INIT)
    const setLoading = () => setStatus(allStatus.LOADING)
    const setSuccess = () => setStatus(allStatus.SUCCESS)
    const setError = () => setStatus(allStatus.ERROR)

    const isInit = allStatus.INIT === status
    const isLoading = allStatus.LOADING === status
    const isSuccess = allStatus.SUCCESS === status
    const isError = allStatus.ERROR === status

    return {
        status,
        setInit,
        setLoading,
        setSuccess,
        setError,
        isInit,
        isLoading,
        isSuccess,
        isError,
    }
}

export default useStatus
